import get from 'lodash/get';

import { PREFIX } from './reducer';

export const getUserData = (state) => ({
  userData: get(state, `${PREFIX}.data`, []),
  isLoading: get(state, `${PREFIX}.isLoading`, false),
  hasError: get(state, `${PREFIX}.hasError`, false),
  isSuccess: get(state, `${PREFIX}.isSuccess`, false),
});
